<template>
  <modal
    width="65"
    v-loading="loading"
    :show-modal="showModal"
    @close-modal="$emit('close-modal')"
  >
    <slot></slot>
    <div v-if="Object.keys(booking).length > 0" id="printable" class="wrapper lg:px-3">
      <div class="flex items-center justify-between mb-4">
        <div class="flex gap-4">
          <div class="flex flex-col" id="mulex" style="border-right: 1px solid">
            MuleEx
            <span id="ref"
              >#{{
                booking.shippingReference ? booking.shippingReference : "----"
              }}</span
            >
          </div>
          <qrcode style="width: 76px; height: 72px" />
        </div>
        <div class="flex gap-4" v-if="!action">
          <span class="cursor-pointer" @click="$emit('close-modal')"
            >Close</span
          >
          <span class="cursor-pointer" @click="printElement">Print</span>
          <span class="cursor-pointer">Share</span>
        </div>
        <div class="flex flex-col">
          <span id="standard">STANDARD SHIPPING</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div style="border: 1px solid #09b78a" class="h-72 min-h-72">
            <div
              class="flex relative h-16 gap-4 items-center"
              style="background: #09b78a1a"
            >
              <svg
                style="position: absolute; top: 0"
                width="64"
                height="68"
                viewBox="0 0 64 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H64V60.4444L30.5672 68L0 60.4444V0Z"
                  fill="#09B78A"
                />
                <path
                  d="M40.4375 27.1875C40.4375 24.9497 39.5486 22.8036 37.9662 21.2213C36.3839 19.6389 34.2378 18.75 32 18.75C29.7622 18.75 27.6161 19.6389 26.0338 21.2213C24.4514 22.8036 23.5625 24.9497 23.5625 27.1875C23.5625 30.6488 26.3319 35.16 32 40.5637C37.6681 35.16 40.4375 30.6488 40.4375 27.1875ZM32 43.125C25.1244 36.8756 21.6875 31.5619 21.6875 27.1875C21.6875 24.4525 22.774 21.8294 24.708 19.8955C26.6419 17.9615 29.265 16.875 32 16.875C34.735 16.875 37.3581 17.9615 39.292 19.8955C41.226 21.8294 42.3125 24.4525 42.3125 27.1875C42.3125 31.5619 38.8756 36.8756 32 43.125Z"
                  fill="white"
                />
                <path
                  d="M32 28.125C32.4973 28.125 32.9742 27.9275 33.3258 27.5758C33.6775 27.2242 33.875 26.7473 33.875 26.25C33.875 25.7527 33.6775 25.2758 33.3258 24.9242C32.9742 24.5725 32.4973 24.375 32 24.375C31.5027 24.375 31.0258 24.5725 30.6742 24.9242C30.3225 25.2758 30.125 25.7527 30.125 26.25C30.125 26.7473 30.3225 27.2242 30.6742 27.5758C31.0258 27.9275 31.5027 28.125 32 28.125ZM32 30C31.0054 30 30.0516 29.6049 29.3483 28.9017C28.6451 28.1984 28.25 27.2446 28.25 26.25C28.25 25.2554 28.6451 24.3016 29.3483 23.5983C30.0516 22.8951 31.0054 22.5 32 22.5C32.9946 22.5 33.9484 22.8951 34.6516 23.5983C35.3549 24.3016 35.75 25.2554 35.75 26.25C35.75 27.2446 35.3549 28.1984 34.6516 28.9017C33.9484 29.6049 32.9946 30 32 30ZM42.125 35.625L45.125 43.125H36.6875V41.25H27.3125V43.125H18.875L21.875 35.625H42.125ZM40.1056 35.625H23.8944L21.6444 41.25H42.3556L40.1056 35.625Z"
                  fill="white"
                />
              </svg>
              <span style="margin-left: 5rem">Pickup From: </span>
            </div>
            <div class="p-4">
              <address>
                {{
                  booking.shipperlocation
                    ? formatAddress(booking.shipperlocation.address) + ","
                    : "N/A"
                }}
                <br />
                {{
                  booking.shipperlocation.city
                    ? booking.shipperlocation.city + ","
                    : ""
                }}
                <br />
                {{
                  booking.shipperlocation.country
                    ? booking.shipperlocation.country
                    : "Nigeria"
                }}
              </address>
              <hr />
              <p class="mt-3 font-semibold">
                {{
                  booking.shipperlocation
                    ? booking.shipperlocation.contactName
                    : "N/A"
                }}
                <span class="text-red">{{
                  booking.shipperlocation
                    ? booking.shipperlocation.mobile
                    : "N/A"
                }}</span>
              </p>
            </div>
            <div class="py-2 px-4" style="border-top: 1px solid #09b78a">
              <span>
                {{
                  booking.sourcePickupTime
                    ? formatDate(
                        booking.sourcePickupTime
                          ? booking.sourcePickupTime
                          : "N/A"
                      )
                    : "Date not available"
                }}
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-6 card2">
          <div style="border: 1px solid #fcc210" class="h-72 min-h-72">
            <div
              class="flex relative h-16 gap-4 items-center"
              style="background: #fcc2101a"
            >
              <svg
                style="position: absolute; top: 0"
                width="64"
                height="68"
                viewBox="0 0 64 68"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0 0H64V60.4444L30.5672 68L0 60.4444V0Z"
                  fill="#FCC210"
                />
                <path
                  d="M40.4375 27.1875C40.4375 24.9497 39.5486 22.8036 37.9662 21.2213C36.3839 19.6389 34.2378 18.75 32 18.75C29.7622 18.75 27.6161 19.6389 26.0338 21.2213C24.4514 22.8036 23.5625 24.9497 23.5625 27.1875C23.5625 30.6488 26.3319 35.16 32 40.5637C37.6681 35.16 40.4375 30.6488 40.4375 27.1875ZM32 43.125C25.1244 36.8756 21.6875 31.5619 21.6875 27.1875C21.6875 24.4525 22.774 21.8294 24.708 19.8955C26.6419 17.9615 29.265 16.875 32 16.875C34.735 16.875 37.3581 17.9615 39.292 19.8955C41.226 21.8294 42.3125 24.4525 42.3125 27.1875C42.3125 31.5619 38.8756 36.8756 32 43.125Z"
                  fill="white"
                />
                <path
                  d="M32 28.125C32.4973 28.125 32.9742 27.9275 33.3258 27.5758C33.6775 27.2242 33.875 26.7473 33.875 26.25C33.875 25.7527 33.6775 25.2758 33.3258 24.9242C32.9742 24.5725 32.4973 24.375 32 24.375C31.5027 24.375 31.0258 24.5725 30.6742 24.9242C30.3225 25.2758 30.125 25.7527 30.125 26.25C30.125 26.7473 30.3225 27.2242 30.6742 27.5758C31.0258 27.9275 31.5027 28.125 32 28.125ZM32 30C31.0054 30 30.0516 29.6049 29.3483 28.9017C28.6451 28.1984 28.25 27.2446 28.25 26.25C28.25 25.2554 28.6451 24.3016 29.3483 23.5983C30.0516 22.8951 31.0054 22.5 32 22.5C32.9946 22.5 33.9484 22.8951 34.6516 23.5983C35.3549 24.3016 35.75 25.2554 35.75 26.25C35.75 27.2446 35.3549 28.1984 34.6516 28.9017C33.9484 29.6049 32.9946 30 32 30ZM42.125 35.625L45.125 43.125H36.6875V41.25H27.3125V43.125H18.875L21.875 35.625H42.125ZM40.1056 35.625H23.8944L21.6444 41.25H42.3556L40.1056 35.625Z"
                  fill="white"
                />
              </svg>
              <span style="margin-left: 5rem">Deliver To: </span>
            </div>
            <div class="p-4">
              <address>
                {{
                  booking.consigneelocation
                    ? formatAddress(booking.consigneelocation.address) + ","
                    : "N/A"
                }}
                <br />
                {{
                  booking.consigneelocation.city
                    ? booking.consigneelocation.city + ","
                    : ""
                }}
                <br />
                {{
                  booking.consigneelocation.country
                    ? booking.consigneelocation.country
                    : "Nigeria"
                }}
              </address>
              <hr />
              <p class="mt-3 font-semibold">
                {{
                  booking.consigneelocation
                    ? booking.consigneelocation.contactName
                    : "N/A"
                }}
                <span class="text-red">{{
                  booking.consigneelocation
                    ? booking.consigneelocation.mobile
                    : "N/A"
                }}</span>
              </p>
            </div>
            <div class="py-2 px-4" style="border-top: 1px solid #fcc210">
              <span>
                {{
                  booking.destinationPickupTime
                    ? formatDate(
                        booking.destinationPickupTime
                          ? booking.destinationPickupTime
                          : "N/A"
                      )
                    : "Date not available"
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4 p-2" style="background: #f9fafc">
        <div class="col-6 col-md-6 col-lg-3 center">
          <p class="flex flex-col gap-1">
            <span class="font-semibold">ORDER CHANNEL</span><span>MuleEx</span>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-3 center">
          <p class="flex flex-col gap-1">
            <span class="font-semibold">ORDER #</span
            ><span>#{{ booking.shippingReference }}</span>
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-3 center">
          <p class="flex flex-col gap-1">
            <span class="font-semibold">INSURED VALUE</span
            ><span
              >N{{
                booking.transaction
                  ? booking.transaction.breakDown != undefined
                    ? JSON.parse(booking.transaction.breakDown).insuranceFee
                    : "0.00"
                  : "0.00"
              }}</span
            >
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-3 center">
          <p class="flex flex-col gap-1">
            <span class="font-semibold">SHIPPING COST</span
            ><span
              >N{{
                booking.transaction ? booking.transaction.totalValue : "0.00"
              }}</span
            >
          </p>
        </div>
        <div class="col-6 col-md-6 col-lg-3 center">
          <p class="flex flex-col gap-1">
            <span class="font-semibold">PAYMENT STATUS</span>
            <span class="flex gap-2">
              {{ booking.paymentStatus }}
            </span>
          </p>
        </div>
      </div>
      <h3 class="font-semibold text-base">Order Items</h3>
      <table class="custom-table responsive-table border-collapse">
        <thead>
          <tr class="shadow-md rounded-lg">
            <th>Item</th>
            <th>Quantity</th>
            <th>Dimension (Cm)</th>
            <th>Gross Weight(kg)</th>
            <th>Total Cost(N)</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="pack in booking.packagees"
            :key="pack.id"
            class="shadow-md rounded-lg"
          >
            <td>{{ pack.description }}</td>
            <td>{{ pack.quantity }}</td>
            <td>{{ pack.length ? pack.length : "N/A" }}</td>
            <td>{{ pack.estimatedWeight }}</td>
            <td>{{ pack.itemValue }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="action" class="flex justify-between items-center pt-4">
      <span class="cursor-pointer" @click="closeModal">cancel</span>
      <base-button
        v-if="booking.id && !hideNext"
        text=" Next"
        @click="action"
      />
      <base-button
        v-if="booking.id && editType === 'receiveShipping'"
        text=" Confirm Receipt"
        @click="action"
      />
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    action: {
      type: Function,
      default: () => {},
    },
    booking: {
      type: Object,
    },
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    editType:{
      type: String,
      default: ''
    },
    hideNext: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false
    };
  },

  methods: {

    printElement() {
      // var domClone = elem.cloneNode(true);

      var $printSection = document.getElementById("printable");

      if (!$printSection) {
        $printSection = document.createElement("div");
        $printSection.id = "printSection";
        document.body.appendChild($printSection);
      }

      // $printSection.innerHTML = "";
      // $printSection.appendChild(domClone);
      window.print();
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted(){
 
    let ship = localStorage.getItem("currentShippment");
    this.shipping = ship ? JSON.parse(ship) : {};
  },
};
</script>

<style scoped>
@media print {
  model.class {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
  }
}

.custom-table {
  margin: 0;
}

@media (max-width: 999px){
  .wrapper{
    padding : 7px 20px 5px 20px;
  }

  .card2{
    margin-top: 20px;
  }
}


.delete-modal {
  text-align: center;
}

#mulex {
  width: 173px;
  font-style: normal;
  font-weight: 600;
  font-size: 48px;
  line-height: 120%;
  letter-spacing: 0.015em;
  color: #10233e;
}

#ref {
  margin-left: 65px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.015em;
}

#standard {
  font-weight: 600;
  font-size: 24px;
  color: #383f51;
}
</style>
